import React from 'react'

const Footer = () => (
  <footer className="footer">
    Copyright {new Date().getFullYear()} NEO CAREER CO., LTD.
  </footer>
)

export default Footer